import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { GasOutagesPage, GasOutagesPageProps } from "./GasOutagesPage";

export const EMPTY_PAGE_CONTENT: GasOutagesPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/outages-faults/gas";

export const GasOutagesPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<GasOutagesPageProps>("gas_and_outages", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <GasOutagesPage {...routeProps} {...content} />;
};
